import { Service, computed, signal } from '@angular/core';

@Service()
export class LoadingService {
  private readonly activeCount = signal(0);

  readonly loading = computed(() => this.activeCount() > 0);

  start(): void {
    this.activeCount.update((n) => n + 1);
  }

  stop(): void {
    this.activeCount.update((n) => (n > 0 ? n - 1 : 0));
  }

  reset(): void {
    this.activeCount.set(0);
  }
}
